export default {
  methods: {
    /**
     * create a select field object
     * @param value
     * @param name
     * @returns {{name: *, value: *}}
     */
    createSelectField(value, name){
      return { value, name }
    }
  }
}
